import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    header: {
      display: 'flex',
      gap: '0.5rem',
      alignItems: 'center',
      marginBottom: '2.5rem',
      '& > h1.MuiTypography-h1': {
        marginBottom: 0,
      },
    },

    buttonWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      '& > button': {
        margin: 0,
        width: '21rem',
      },
    },
  }),
)
